module.exports = __webpack_public_path__ + "5d8fb114abc016223203a0b9b25e2540.png";